import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as tableActions from '../../../store/actions/table';
import TeamForm from './TeamForm';
import { Scrollbar } from 'react-scrollbars-custom';
import * as singleActions from '../../../store/actions/single';
import PageLoader from "../../Common/PageLoader";

class SingleTeam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: []
    };
  }

  componentDidMount(props) {
    this.init();
  }

  componentDidUpdate(props, state) {
    if (this.props.match.params.id !== props.match.params.id) {
      this.init();
    }
  }

  init = () => {
    if (this.props.match.params.id === 'new') {
      this.props.setSingle({});
    } else {
      this.props.get(this.props.match.params.id, this.props.auth.token._id);
    }
  };

  render() {
    return (
      <PageLoader loaded={!this.props.single.loading}>
        <div className={'page-container elevated padded rounded school-profile profile-page'}>
          <Scrollbar
            className={'feis-page-scroller no-padding-scroller'}
            noScrollX={true}
            onUpdate={this.handleUpdate}
            style={{ height: 'calc(100vh - 90px)' }}>
            <TeamForm />
          </Scrollbar>
        </div>
      </PageLoader>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  table: state.table,
  single: state.single
});

const mapDispatchToProps = (dispatch) => ({
  getTableData: (view, skip, limit, sort, token, mode) => {
    dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, {}, token, mode));
  },
  getTableDataWithQuery: (view, skip, limit, sort, query, token, mode) => {
    dispatch(tableActions.getTableDataWithQuery(view, skip, limit, sort, query, token, mode));
  },
  get: (id, token) => {
    dispatch(singleActions.getSingle('teams', id, token));
  },
  setSingle: (d) => {
    dispatch(singleActions.setSingleEntryHard(d));
  }
});

const Connected = withRouter(connect(mapStateToProps, mapDispatchToProps)(SingleTeam));

class SingleTeamContainer extends React.Component {
  render() {
    return (
      <div>
        <Connected {...this.props} />
      </div>
    );
  }
}

export default SingleTeamContainer;
